import ChangedPasswordForm from './ChangedPasswordForm';

export default ChangedPasswordForm;


// WEBPACK FOOTER //
// ./src/components/ChangedPasswordForm/index.jsx